/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LocationResponse model module.
* @module model/LocationResponse
* @version 2020-12-7
*/
export default class LocationResponse {
    /**
    * Constructs a new <code>LocationResponse</code>.
    * 地図上の位置
    * @alias module:model/LocationResponse
    * @class
    * @param latitude {Number} 緯度
    * @param longitude {Number} 経度
    */

    constructor(latitude, longitude) {
        
        
        this['latitude'] = latitude;
        this['longitude'] = longitude;
        
    }

    /**
    * Constructs a <code>LocationResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LocationResponse} obj Optional instance to populate.
    * @return {module:model/LocationResponse} The populated <code>LocationResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LocationResponse();
                        
            
            if (data.hasOwnProperty('latitude')) {
                obj['latitude'] = ApiClient.convertToType(data['latitude'], 'Number');
            }
            if (data.hasOwnProperty('longitude')) {
                obj['longitude'] = ApiClient.convertToType(data['longitude'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 緯度
    * @member {Number} latitude
    */
    'latitude' = undefined;
    /**
    * 経度
    * @member {Number} longitude
    */
    'longitude' = undefined;




}
